export class ArticleSourceSearchRequest {
  Culture: string;
  MaxResults: number;
  VrmArticleID: number;
  ItemGroup: number = -1;
  ItemGroupDescription: string;
  Description: string;
  ItemNumber: string;
  Ean: string;
  SupplierCode: number = -1;
  SupplierGroup: string;
  ItemNumberSupplier: string;
  TecdocBrandId: number;
  TecdocGenartId: number;
  WithHistory: boolean;
  AllItemsMustMatch: boolean;
}